import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import "@/App.css";
import "@/index.css";
import SmoothScroll from '@/components/SmoothScroll';
import Footer from '@/components/Footer';
import WhatsAppFab from '@/components/WhatsAppFab';
import Home from '@/pages/Home';

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 50);
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <ScrollManager />
          <main>
            <Routes>
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppFab />
          <Toaster
            position="bottom-center"
            toastOptions={{
              style: {
                background: '#022B22',
                color: '#D8C28B',
                border: '1px solid #B49A55',
                borderRadius: 0,
                fontFamily: 'Manrope, sans-serif',
              },
            }}
          />
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
